import { Autocomplete, TextField } from "@mui/material";

export type OrganizationOption = {
  id: number;
  code?: string;
  department_name?: string | null;
  group_name?: string | null;
};

type OrganizationSelectBaseProps = {
  name: string;
  label: string;
  options: OrganizationOption[];
  disabled?: boolean;
};

type OrganizationSelectSingleProps = OrganizationSelectBaseProps & {
  multiple?: false;
  value: OrganizationOption | null;
  onChange: (value: OrganizationOption | null) => void;
};

type OrganizationSelectMultiProps = OrganizationSelectBaseProps & {
  multiple: true;
  value: OrganizationOption[];
  onChange: (value: OrganizationOption[]) => void;
};

export type OrganizationSelectProps =
  | OrganizationSelectSingleProps
  | OrganizationSelectMultiProps;

const getOrganizationLabel = (organization: OrganizationOption): string => {
  if (organization.group_name) {
    return `${organization.department_name || ""}-${organization.group_name}`;
  }
  return organization.department_name || organization.code || "";
};

const OrganizationSelect = (props: OrganizationSelectProps) => {
  const {
    name,
    label,
    options,
    value,
    onChange,
    multiple = false,
    disabled = false,
  } = props;

  if (multiple) {
    const multiProps = props as OrganizationSelectMultiProps;
    return (
      <Autocomplete
        fullWidth
        size="small"
        multiple
        disabled={disabled}
        options={options}
        value={multiProps.value}
        getOptionLabel={getOrganizationLabel}
        isOptionEqualToValue={(option, selected) => option.id === selected.id}
        renderInput={(params) => (
          <TextField {...params} name={name} label={label} />
        )}
        onChange={(_event, newValue) => multiProps.onChange(newValue)}
      />
    );
  }

  const singleProps = props as OrganizationSelectSingleProps;
  return (
    <Autocomplete
      fullWidth
      size="small"
      disabled={disabled}
      options={options}
      value={singleProps.value}
      getOptionLabel={getOrganizationLabel}
      isOptionEqualToValue={(option, selected) => option.id === selected.id}
      renderInput={(params) => (
        <TextField {...params} name={name} label={label} />
      )}
      onChange={(_event, newValue) => singleProps.onChange(newValue)}
    />
  );
};

export default OrganizationSelect;
